import { Trans, useTranslation } from 'react-i18next';
import Search from '../search/search';
import PlayerCard from './playerCard';
import { ExistingPlayerProps } from './selectPlayerModal.types';
import styles from './selectPlayerModal.module.css';

const ExistingPlayer = (props: ExistingPlayerProps) => {
  const { t } = useTranslation();
  return props.playerLoading ? (
    <Trans i18nKey="selectPlayer.loading" />
  ) : (
    <>
      <Search
        query={props.query}
        onChange={(value: string) => props.setQuery(value)}
        placeholder={t('selectPlayer.searchByPlayerId')}
        containerClass={styles.searchContainer}
        iconSize={18}
      />
      {props.filteredPlayers.length > 0 ? (
        <div className={styles.playersGallery}>
          {props.filteredPlayers.map((player) => (
            <PlayerCard
              key={player.playerId}
              player={player}
              selectedPlayer={props.selectedPlayer}
              onClick={props.setSelectedPlayer}
            />
          ))}
        </div>
      ) : (
        <Trans i18nKey="selectPlayer.noResults" />
      )}
    </>
  );
};

export default ExistingPlayer;
